import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// Компонент для главного контейнера с боковой панелью
export const MainLayoutContainer = styled(Box)(({ theme }) => ({
    height: '100dvh',
    maxHeight: '100svh',
    overflow: 'hidden',
    display: 'flex',
    gap: theme.spacing(3),
    // На мобильных устройствах делаем колонку, на десктопах - строку
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
    },
}));

// Компонент для боковой панели
export const Sidebar = styled(Box)(({ theme }) => ({
    width: 200,
    flexShrink: 0,
    height: 'fit-content',
    // На мобильных устройствах ширина 100%
    [theme.breakpoints.down('md')]: {
        width: '100%',
    },
}));

// Компонент для сетки карточек
export const ResponsiveCardGrid = styled(Box)(({ theme }) => ({
    display: 'grid',
    gap: theme.spacing(3),
    // На мобильных устройствах одна колонка, на экранах побольше - несколько
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
    },
}));